import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Sidebar.css';
import { NAV_LIST } from '../../../utils/constants';

const Sidebar = ({ active, isAllowed, getAuthSDK }) => {
  const navigate = useNavigate();

  const handleNavigate = (nav) => {
    if (nav.id === 'home') {
      navigate('/');
    } else {
      if (nav.id === 'workflows' || nav.id === 'portal') {
        // Handle special routes if needed
      } else {
        navigate('/' + nav.id);
      }
    }
  };

  const handleClick = async (nav) => {
    // First, call parent's getAuthSDK() to ensure isAllowed is updated
    if (getAuthSDK) {
      const allowed = await getAuthSDK(); // Wait for permission check
      if (!allowed) {
        toast.warning(
          "Sorry, you don't have permission to access this. Please contact the administrator for access.",
          {
            position: 'top-right',
            autoClose: 3000,
          }
        );
        return; // Stop navigation
      }
    }

    handleNavigate(nav);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-link-wrap">
        {NAV_LIST.map((nav) => {
          const labelText =
            typeof nav.label === 'string' ? nav.label : nav.label?.props?.children;

          return (
            <div
              key={nav.id}
              className={`sidebar-link ${active === nav.id ? 'active' : ''}`}
              style={{
                opacity: nav.label === 'Rules & Prompt Manager' && !isAllowed ? 0.5 : 1,
                cursor: nav.label === 'Rules & Prompt Manager' && !isAllowed ? 'not-allowed' : 'pointer',
              }}
            >
              {nav.icon}
              <span onClick={() => handleClick(nav)}>{nav.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
